module.exports = __webpack_public_path__ + "img/desk2.2b514ee7.png";